'use strict';

const { queryFirst } = require('../../domUtil');
const { storeDetail } = require('../../templates').shippingPreferenceTemplates;
const { STORE_DETAIL_SELECTOR, STORE_DETAIL_CONTAINER_SELECTOR } = require('./constants');

/**
 * Function to get store detail within product container
 * @param {HTMLElement} productContainerEl - Product container Element
 * @returns {Object} returns the target as a DOM node
 */
function getStoreDetailEl(productContainerEl) {
    return queryFirst(STORE_DETAIL_SELECTOR, productContainerEl);
}

/**
 * Function to get store detail container within product container
 * @param {HTMLElement} productContainerEl - Product container Element
 * @returns {Object} returns the target as a DOM node
 */
function getStoreDetailContainerEl(productContainerEl) {
    return queryFirst(STORE_DETAIL_CONTAINER_SELECTOR, productContainerEl);
}

/**
 * Function to inject store details DOM elements within product container
 * @param {Object} store - Store object
 * @param {HTMLElement} productContainerEl - Product container Element
 * @param {HTMLElement?} storeDetailContainerEl - Store detail container element
 */
function addStoreDetail(store, productContainerEl, storeDetailContainerEl) {
    storeDetailContainerEl = storeDetailContainerEl || getStoreDetailContainerEl(productContainerEl);
    const { ID, name, address1, city, stateCode, postalCode } = store;
    const storeDetailHTML = storeDetail(ID, name, address1, city, stateCode, postalCode);

    $(storeDetailContainerEl).html(storeDetailHTML);
}

module.exports = {
    getStoreDetailEl: getStoreDetailEl,
    getStoreDetailContainerEl: getStoreDetailContainerEl,
    addStoreDetail: addStoreDetail
};
